import "library/styles/components/stripe-button.scss";

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'library/helpers/modal';
import StripeModal from 'library/components/stripe-modal';
import Stripe from 'library/helpers/stripe';

class GeneralModal extends Component {
  static defaultProps = {
    close: ()=>{}
  }

  state = {
    timer: 10
  }

  componentDidMount() {
    this._isMounted = true;

    setInterval(()=>{
      this.setState(({...n})=>{
        n.timer = Math.max(0, n.timer-1);
        return n;
      }, () => {
        if (this.state.timer === 0) {
          this.close();
        }
      })
    }, 1000)
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  close = () => {
    if (this._isMounted) {
      this.props.close();
    }
  }

  render() {
    const {
      className,
      children
    } = this.props;

    return (
      <div className="stripe-result-modal-inner">
        <a className="stripe-result-modal-inner-header-close" onClick={this.close} href="javascript:void(0)">×</a>
        <div className={["stripe-result-modal-body", className].filter(c=>c).join(' ')}>
          { children }
          <p><small>this will close in {this.state.timer} seconds</small></p>
        </div>
      </div>
    )
  }
}

const SuccessModal = ({ data, close }) => (
  <GeneralModal className="stripe-result-success" close={close}>
    <h2>Success</h2>
    <p>{ data.subscription.plan.name } has been subscribed. It will renew automatically { data.subscription.end }</p>
    <button onClick={close}>Close</button>
  </GeneralModal>
)

const ErrorModal = ({ data, close }) => (
  <GeneralModal  className="stripe-result-error" close={close}>
    <h2>Error</h2>
    {
      (((data||{}).errors||{}).messages||['Unknown Error. Please try again']).map(e=>(
        <p>{ e }</p>
      ))
    }
    <button onClick={close}>Close</button>
  </GeneralModal>
)

export default class PurchaseButton extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    onComplete: ()=>{}
  }

  static defaultProps = {
    onClick: ()=>{},
    account: {},
    component:'button'
  }

  constructor(...params) {
    super(...params);
    Stripe.inject();
  }

  state = {
    active: false
  }

  openPurchaseModal = (e) => {
    const {
      amount,
      label,
      account,
      onClick
    } = this.props;

    if (typeof onClick === 'function') {
      onClick(e);
    }

    this.closeModal();

    if (!this.modal) {
      this.modal = new Modal('stripe-modal', true, {
        className: 'stripe-modal'
      });
    }

    this.modal.render(StripeModal, {
        apiKey: __STRIPE_API_KEY__,
        name: [account.first_name,account.last_name].filter(c=>c).join(' '),
        email: account.email,
        label: label,
        amount: amount,
        onComplete: this.handleComplete,
        onError: this.handleError,
        close: this.closeModal
    })
  }

  openGeneralModal = (ModalComponent, data, closeFunc) => {
    this.closeModal();

    if (!this.modal) {
      this.modal = new Modal('stripe-result-modal', true, {
        className: 'stripe-result-modal'
      });
    }

    this.modal.render(ModalComponent, {
      data: data,
      close: closeFunc || this.closeModal
    })
  }

  closeModal = () => {
    if (this.modal && this.modal.isRendered) {
      this.modal.unmount();
      this.modal = null;
    }
  }

  handleComplete = (data) => {
    this.openGeneralModal(SuccessModal, data, () => {
      this.props.onComplete()
    });
  }

  handleError = ({ data }) => {
    this.openGeneralModal(ErrorModal, data, () => {
      this.openPurchaseModal()
    });
  }

  componentWillUnmount() {
    this.closeModal();
  }

  render() {
    const {
      component:Component='button',
      children,
      account,
      onClick,
      label,
      amount,
      ...props
    } = this.props;

    const {
      active
    } = this.state;

    return (
      <Component {...props} onClick={this.openPurchaseModal}>
        {this.props.children}
      </Component>
    )
  }
}
